import { Tooltip, ActionIcon } from "@mantine/core";
import { IconQuestionMark } from "@tabler/icons-react";

interface ColumnTooltipProps {
  text: string;
}

export function ColumnTooltip({ text }: ColumnTooltipProps) {
  return (
    <Tooltip label={text} multiline w={260} withArrow position="top">
      <ActionIcon
        variant="transparent"
        size={16}
        radius="xl"
        color="dimmed"
        style={{
          border: "1px solid var(--mantine-color-gray-4)",
          cursor: "help",
        }}
      >
        <IconQuestionMark size={10} />
      </ActionIcon>
    </Tooltip>
  );
}
